<section class="content-header">

  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1 class="m-0 text-dark">Testing</h1>
      </div>

    </div>
    <!-- /.row -->
  </div>
  <!-- /.container-fluid -->
</section>
<section class="content">
  <!-- Default box -->
  <div class="container-fluid"  *ngIf="isReadMode">

    <div class="card">

      <div class="card-body">

        
      <div class="row">
        <div class="col">
          <label>Search by Vehicle No.</label> 
          <ng-select [items]="vehicles" bindLabel="vehicleNo" autofocus bindValue="vehicleNo"
                     [(ngModel)]="selectedvehicleNo">
          </ng-select>
        </div>
        <div class="col">
         <label>Search by Product Category</label> 
         <ng-select [items]="products" bindLabel="productName" autofocus bindValue="productId"
                    [(ngModel)]="selectedproductId">
                </ng-select>
       </div>
       <div class="col">
        <label>Search by Product Name</label> 
        <input [(ngModel)]="seachText" class="form-control">
      </div>
       <div class="col">
        <label>From Date</label> <input [(ngModel)]="fromDate" class="form-control" type="date" (change)="dateChange()">
      </div>
      <div class="col">
        <label>End Date</label> <input [(ngModel)]="endDate" [min]="fromDate" class="form-control" type="date">
      </div>
     </div>
     <br />
     <div class="col"><input type="button" class="btn btn-primary"
                     value="Search" (click)="search()" /> &nbsp;&nbsp;&nbsp;
                      <input type="button" class="btn btn-primary"
                     value="Reset" (click)="reset()" /></div>
     
    
     <br />
     <!-- <div class="row">
      <div class="col">
        <label>State Name : {{state_name}}</label>
      </div>
     </div> -->
     <div class="box-header with-border">
      <p style="float:right" *ngIf="role=='USER'">
        <!-- <a href="./add-testing" class="btn btn-link"> -->
        <a [routerLink]="['/add-testing']" class="btn btn-link">Add New Testing</a></p>
    </div>
     <div class="box-header with-border">
      <p style="float:right" *ngIf="stateCode">
        <a [routerLink]="['/list-testing-statewise']" class="btn btn-link">Back</a></p>
        <!-- <a href="./list-testing-statewise" class="btn btn-link">Back</a></p> -->
  </div>
  <br />
  <br />
  
      <div class="row" *ngIf="role!='USER'">
        <div class="col">
          <label>State Name : {{state_name}}</label>
        </div>

        <label for="records">Records per page:</label>
        <select name="records" id="records" (change)="excelLength($event.target.value)">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="0">All</option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

        
        <button style="float:right" class="btn btn-primary" (click)="exportexcel()">
          Export To Excel
        </button>

      </div>

      <table class="table table-striped table-hover table-bordered">
        <thead class="thead">
          <tr>
            <td style="font-weight:bold">Sr. No.</td>
            <td style="font-weight:bold">Vehicle No.</td>
            <td style="font-weight:bold;width:25%;">Product</td>
            <td style="font-weight:bold">Product Name</td>
            <td style="font-weight:bold">Sample Id</td>
            <td style="font-weight:bold">Tested On</td>
            <td style="font-weight:bold; text-align: center;">Actions</td>
            <!-- <td style="font-weight:bold; text-align: center;">Sample Result</td>
            <td style="font-weight:bold; text-align: center;">Additional Sample Result</td> -->
            <td style="font-weight:bold; text-align: center;">Final Sample Result</td>
            <td style="font-weight:bold; text-align: center;">Action Taken On Failed Samples</td>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let testing of testingsRecordData | paginate : {id: 'pagination1', itemsPerPage: 10, currentPage : p}; let i=index">
            <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
            <td>{{ testing.vehicleNo }} <span *ngIf="testing.vehicleNo==''"> {{ testing.createdBy }} </span> </td>
            <td   style="word-wrap: break-word;" >{{ testing.productName }}</td>
            <td>{{ testing.testingProductName || testing.testProductName }}</td>
            <td>{{ testing.sampleId }}</td>
            <td>{{ testing.createdOn | date: 'dd-MM-yyyy'}}</td>
              <td>
                <a [routerLink]="['/view-sample/',testing.sampleId]" class="btn btn-primary">View Parameters</a>&nbsp;&nbsp;&nbsp;  
                <a *ngIf="testing.filePath" href="{{apiURL+'/fsw/document-view'+testing.filePath}}" target="_blank" class="btn btn-primary">View Report</a>&nbsp;&nbsp;&nbsp;    
                <a *ngIf="!testing.filePath && testing.sampleId" href="{{apiURL+'/fsw/generatePdf/'+testing.sampleId}}" target="_blank" class="btn btn-primary" class="btn btn-primary">View PDF Report</a>&nbsp;&nbsp;&nbsp;
                <input type="button" (click)="deleteTesting(testing)" [disabled]="role!='ADMIN' && role!='SO' " value="Delete" class="btn btn btn-danger">
            </td>
            <!-- <td>
              <b *ngIf="testing.sampleResult=='Pass' " style="color:green; text-align: center;">{{testing.sampleResult}}</b>
              <b *ngIf="testing.sampleResult=='Fail' " style="color:red; text-align: center;">{{testing.sampleResult}}</b>
            </td>
            <td>
              <b *ngIf="testing.sampleResultOther=='Pass' " style="color:green; text-align: center;">{{testing.sampleResultOther}}</b>
              <b *ngIf="testing.sampleResultOther=='Fail' " style="color:red; text-align: center;">{{testing.sampleResultOther}}</b>
            </td> -->
            <td>
              <b *ngIf="(testing.sampleResult=='Pass' && testing.sampleResultOther=='Pass') || (testing.sampleResult=='Pass' && testing.sampleResultOther==null) || (testing.sampleResult==null && testing.sampleResultOther=='Pass') " style="color:green; text-align: center;">Pass</b>
              <b *ngIf="(testing.sampleResult=='Fail' || testing.sampleResultOther=='Fail')" style="color:red; text-align: center;">Fail</b>
            </td>
            <td *ngIf="testing.actionTaken==null">
              <input *ngIf="(testing.sampleResult=='Fail' || testing.sampleResultOther=='Fail')" type="button" (click)="saveActionTaken(testing)" [disabled]="role!='ADMIN' && role!='SO' " value="Take Action" class="btn btn btn-danger">
            </td>
            <td *ngIf="testing.actionTaken!=null" style="color:blue;">{{testing.actionTaken}}</td>
          </tr>
        </tbody>
      </table>

      <pagination-controls id="pagination1" (pageChange)="pageChange($event)" class="float-right"></pagination-controls>

      <div>
      <table hidden class="table table-striped table-hover table-bordered" id="componentID">
        <thead class="thead">
          <tr>
            <td style="font-weight:bold">Sr. No.</td>
            <td style="font-weight:bold">Vehicle No.</td>
            <td style="font-weight:bold;width:25%;">Product</td>
            <td style="font-weight:bold">Product Name</td>
            <td style="font-weight:bold">Sample Id</td>
            <td style="font-weight:bold">Tested On</td>
            <!-- <td style="font-weight:bold; text-align: center;">Sample Result</td>
            <td style="font-weight:bold; text-align: center;">Additional Sample Result</td> -->
            <td style="font-weight:bold">Final Sample Result</td>
            <td style="font-weight:bold; text-align: center;">Action Taken On Failed Samples</td>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let testing of testingsRecordData | paginate : {id: 'pagination2', itemsPerPage: selectCount, currentPage : p1}; let i=index">
            <!-- <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td> -->
            <td>{{i+1}}</td>
            <td>{{ testing.vehicleNo }} <span *ngIf="testing.vehicleNo==''"> {{ testing.createdBy }} </span> </td>
            <td   style="word-wrap: break-word;" >{{ testing.productName }}</td>
            <td>{{ testing.testingProductName || testing.testProductName }}</td>
            <td>{{ testing.sampleId }}</td>
            <td>{{ testing.createdOn | date: 'dd-MM-yyyy'}}</td>
            <!-- <td>
              <b *ngIf="testing.sampleResult=='Pass' " style="color:green; text-align: center;">{{testing.sampleResult}}</b>
              <b *ngIf="testing.sampleResult=='Fail' " style="color:red; text-align: center;">{{testing.sampleResult}}</b>
            </td>
            <td>
              <b *ngIf="testing.sampleResultOther=='Pass' " style="color:green; text-align: center;">{{testing.sampleResultOther}}</b>
              <b *ngIf="testing.sampleResultOther=='Fail' " style="color:red; text-align: center;">{{testing.sampleResultOther}}</b>
            </td> -->
            <td>
              <b *ngIf="(testing.sampleResult=='Pass' && testing.sampleResultOther=='Pass') || (testing.sampleResult=='Pass' && testing.sampleResultOther==null) || (testing.sampleResult==null && testing.sampleResultOther=='Pass') " style="color:green; text-align: center;">Pass</b>
              <b *ngIf="(testing.sampleResult=='Fail' || testing.sampleResultOther=='Fail')" style="color:red; text-align: center;">Fail</b>
            </td>
            <td *ngIf="testing.actionTaken==null">
              <input *ngIf="(testing.sampleResult=='Fail' || testing.sampleResultOther=='Fail')" type="button" (click)="saveActionTaken(testing)" [disabled]="role!='ADMIN' && role!='SO' " value="Take Action" class="btn btn btn-danger">
            </td>
            <td *ngIf="testing.actionTaken!=null" style="color:blue;">{{testing.actionTaken}}</td>
          </tr>
        </tbody>
        <pagination-controls id="pagination2" (pageChange)="p1 = $event" class="float-right"></pagination-controls>
      </table>
    </div>
    </div>
    </div>
  </div>
  <div class="container-fluid" *ngIf="isDeleteMode">
    <div class="card">
      <div class="card-body">
        <div class="container" *ngIf="isDeleteMode">
          <div class="row">
            
            <div class="col-md-2" style="font-weight:bold">
              <label for="">Product Name :</label>
            </div>
            <div class="col-md-3">
              <label>{{productName}}</label>
            </div>

            <div class="col-md-1">

            </div>
            <div class="col-md-2" style="font-weight:bold">
              <label for="">Vehicle No. :</label>

            </div>
            <div class="col-md-4">
              <label>{{vehicleNo}}</label>
            </div>
            

          </div>
          <div class="row">
           <div class="col-md-2" style="font-weight:bold">
              <label for="">State Name :</label> 
            </div>
            <div class="col-md-3">
              <label>{{stateName}}</label>
            </div>

            <div class="col-md-1">

            </div>
            <div class="col-md-2" style="font-weight:bold">
              <!-- <label for="">Trainer Name :</label> -->

            </div>
            <div class="col-md-4">
              <!-- <label>{{trainerName}}</label> -->
            </div>
            

          </div>
          
            <div class="row">
              <div class="col-md-1" style="font-weight:bold;">
                <label for="">Remark :</label>
              </div>
              <div class="col-md-4">
                <textarea  [(ngModel)]="adminRemark" class="form-control"> </textarea>
              </div>
              <div class="col-md-2">

              </div>

            </div>
            <br/>
            <div class="row" style="text-align:center;">
              <div class="col"><input type="button" class="btn btn-danger"  value="Delete" (click)="ondeleteTestingSubmit()" />
              </div>
              <div class="col">
                <!-- <a href="./list-testing/{{stateCode}}" class="btn btn-link">fef</a> -->
                <!-- <a [routerLink]="['/','list-testing',stateCode]" class="btn btn-link">Back</a> -->
                <a (click)="backDeleteStateWiseTestingData()" class="btn btn-link">Back</a>

              </div>
              
            </div>
             <!-- <div *ngIf="success" class="alert alert-success alert-dismissible fade show" role="alert">
              <strong>Success!</strong> Your data has been deleted successfully.
              <button (click)="closeAlert()" type="button" class="close" data-dismiss="alert"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
            
          
        </div>
      </div>

    </div>
  </div>

  <div class="container-fluid" *ngIf="isActionTakenMode">
    <div class="card">
      <div class="card-body">
        <div class="container" *ngIf="isActionTakenMode">
          <div class="row">
            
            <div class="col-md-2" style="font-weight:bold">
              <label for="">Product Name :</label>
            </div>
            <div class="col-md-3">
              <label>{{productName}}</label>
            </div>

            <div class="col-md-1">

            </div>
            <div class="col-md-2" style="font-weight:bold">
              <label for="">Vehicle No. :</label>

            </div>
            <div class="col-md-4">
              <label>{{vehicleNo}}</label>
            </div>
            

          </div>
          <div class="row">
           <div class="col-md-2" style="font-weight:bold">
              <label for="">State Name :</label> 
            </div>
            <div class="col-md-3">
              <label>{{stateName}}</label>
            </div>

            <div class="col-md-1">

            </div>
            <div class="col-md-2" style="font-weight:bold">
              <!-- <label for="">Trainer Name :</label> -->

            </div>
            <div class="col-md-4">
              <!-- <label>{{trainerName}}</label> -->
            </div>
            

          </div>
          
            <div class="row">
              <div class="col-md-1" style="font-weight:bold;">
                <label for="">Action Taken:</label>
              </div>
              <div class="col-md-4">
                <textarea  [(ngModel)]="actionTaken" class="form-control"> </textarea>
              </div>
              <div class="col-md-2">

              </div>

            </div>


            <br/>

            <div class="row" style="text-align:center;">
              <div class="col"><input type="button" class="btn btn-danger"  value="Action Taken" (click)="onActionTakenSubmit()" />
              </div>
              <div class="col">
                <a (click)="backStateWiseData()" class="btn btn-link">Back</a>
              </div>
            </div>
            
             <!-- <div *ngIf="success" class="alert alert-success alert-dismissible fade show" role="alert">
              <strong>Success!</strong> Your data has been deleted successfully.
              <button (click)="closeAlert()" type="button" class="close" data-dismiss="alert"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
            
          
        </div>
      </div>

    </div>
  </div>
</section>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>
